import { render, staticRenderFns } from "./EpBdFactoryAreaList.vue?vue&type=template&id=623a8582&scoped=true&"
import script from "./EpBdFactoryAreaList.vue?vue&type=script&lang=js&"
export * from "./EpBdFactoryAreaList.vue?vue&type=script&lang=js&"
import style0 from "./EpBdFactoryAreaList.vue?vue&type=style&index=0&id=623a8582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623a8582",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('623a8582')) {
      api.createRecord('623a8582', component.options)
    } else {
      api.reload('623a8582', component.options)
    }
    module.hot.accept("./EpBdFactoryAreaList.vue?vue&type=template&id=623a8582&scoped=true&", function () {
      api.rerender('623a8582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/EpBdFactoryAreaList.vue"
export default component.exports